import React from 'react';
import { ConversationItem } from './ConversationItem';
import { Input } from '../ui/Input';
import { Search } from 'lucide-react';
interface Conversation {
  id: string;
  name: string;
  handle: string;
  avatar: string;
  lastMessage: string;
  timestamp: string;
  unreadCount: number;
  isOnline: boolean;
}
interface ConversationListProps {
  conversations: Conversation[];
  activeId?: string;
  onSelect: (id: string) => void;
}
export function ConversationList({
  conversations,
  activeId,
  onSelect
}: ConversationListProps) {
  return <div className="flex flex-col h-full bg-white border-r" data-id="element-106">
      <div className="p-4 border-b" data-id="element-107">
        <h2 className="text-xl font-bold mb-4" data-id="element-108">Messages</h2>
        <div className="relative" data-id="element-109">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" data-id="element-110" />
          <Input placeholder="Search conversations..." className="pl-9 bg-gray-50 border-gray-200" data-id="element-111" />
        </div>
      </div>
      <div className="flex-1 overflow-y-auto" data-id="element-112">
        {conversations.map(conv => <ConversationItem key={conv.id} {...conv} isActive={activeId === conv.id} onClick={() => onSelect(conv.id)} data-id="element-113" />)}
      </div>
    </div>;
}